export default class C046CommentsRatings {
  constructor(node, props) {
    this.node = node;
    this.props = props;
  }

  init() {
    const commentsSections = this.node.querySelectorAll('[data-components-part="comments"]');

    commentsSections.forEach((comments) => {
      const element = comments;
      const url = element.dataset.commentsUrl;
      const adminUrl = element.dataset.adminUrl;

      this.initCommentsIframe(element, adminUrl ? adminUrl : url);
    });

    const numberSections = this.node.querySelectorAll('[data-component-part="numbers"]');

    numberSections.forEach((numbers) => {
      const element = numbers;
      const baseUrl = this.node.querySelector('[data-component-var="baseUrl"]').textContent;
      const uid = this.node.querySelector('[data-component-var="uid"]').textContent;

      this.initNumbers(element, baseUrl, [uid]);
    });

  }

  initCommentsIframe(element, url) {
    var iframeHeight;

    var src = url + '#' + encodeURIComponent(document.location.href);
    // Append the Iframe into the DOM.

    element.insertAdjacentHTML('beforeend', `
        <iframe class="ratings-comments__iframe" src="${src}"
            scrolling="no"
            frameborder="0">
        </iframe>
    `);

    // Setup a callback to handle the dispatched MessageEvent event. In cases where
    // window.postMessage is supported, the passed event will have .data, .origin and
    // .source properties. Otherwise, this will only have the .data property.
    window.addEventListener('message', function (e) {
      if (!e || !e.data || typeof e.data !== 'string') {
        return;
      }
      const iframe = element.querySelector('.ratings-comments__iframe');
      var h = Number(e.data.replace(/.*if_height=(\d+)(?:&|$)/, '$1'));

      if (!isNaN(h) && h > 0 && h !== iframeHeight) {
        iframeHeight = h;
        iframe.style.height = `${iframeHeight}px`;
      }
    }, false);
  }

  initNumbers(element, baseUrl, ids) {
    const query = ids.map(uid => `ids=${uid}`).join('&');

    fetch(baseUrl + 'votes/multi?' + query)
      .then(response => response.json())
      .then(data => {
        ids.forEach(id => {
          const socialBlock = element;
          const votesCount = data[id].votes;
          const commentsCount = data[id].num_comments;

          const votesElement = socialBlock.querySelector('[data-component-part="votes"]');
          votesElement.textContent = votesCount;

          const commentsElement = socialBlock.querySelector('[data-component-part="num_comments"]');
          commentsElement.textContent = commentsCount;
        });
      });
  }


  ready() {
    this.init();
  }

  clear() {
  }

  cmsRefresh() {
    this.init();
  }
}
